import {qualityAssuranceOrdersForm} from '../qualityAssuranceOrders/reducers/qualityAssuranceOrdersForm';
import {scanningForm, scanningWarehouseDenialCauseForm} from '../picking/reducers/scanning';
import {techniciansAssignmentForm} from '../accessories/reducers/techniciansAssignmentForm';
import {iccCategoriesParametersForm, iccMadParametersForm} from '../iccMatrix/reducers';
import {warehouseDenialCauseForm} from '../picking/reducers/warehouseDenialCauses';
import {stockAdjustmentForm} from '../stockAdjustment/reducers/form';
import {transferForm} from '../transfers/reducers/transfers';
import {invoicingForm} from '../binning/reducers/invoicing';
import {partForm} from '../part/reducers/analysisAndQuery';
import budgetsVehicles from '../budgetVehicles/reducers';
import {checkingForm} from '../binning/reducers/checking';
import {parametersForm} from '../parameter/reducers';
import {masterVehicleForm} from '../masterVehicle/reducers';
import {shiftForm} from '../picking/reducers/shifts';
import {invoiceForm} from '../invoiceLoad/reducers';
import {zoneForm} from '../picking/reducers/zones';
import {providerForm} from '../provider/reducers';
import {originForm} from '../origin/reducers';
import {dispatchOrderForm} from '../dispatchOrders/reducers/dispatchOrderForm';
import {errorCodesForm} from '../twcMaintenance/reducers/warrantyErrorCodes';
import {tasksCodesForm} from '../twcMaintenance/reducers/warrantyTasksCodes';
import {userForm} from '../users/reducers/form';
import {mailGroupForm} from '../mailGroup/reducers/form';
import {advisorManagementForm} from '../budgetVehicles/reducers/advisorManagement';
import {exemptionManagementForm} from '../budgetVehicles/reducers/exemptionManagement';
import {clientManagementForm} from '../budgetVehicles/reducers/clientManagement';

export const ORIGIN = {
  'name': 'origin',
  'reducer': originForm,
  'initialValues': {
    'code': '',
    'origin': '',
    'status': true,
  },
};

export const PROVIDER = {
  'name': 'provider',
  'reducer': providerForm,
};

export const PARAMETERS_FORM = {
  'name': 'parameters',
  'reducer': parametersForm,
};

export const ERROR_CODES_FORM = {
  'name': 'parameters',
  'reducer': errorCodesForm,
};

export const TASKS_CODES_FORM = {
  'name': 'parameters',
  'reducer': tasksCodesForm,
};

export const MASTER_VEHICLE_FORM = {
  'name': 'masterVehicle',
  'reducer': masterVehicleForm,
};

export const MANAGE_COLORS_FORM = {
  'name': 'manageColorsForm',
  'reducer': budgetsVehicles.manageColorsForm,
};

export const PART = {
  'name': 'part',
  'reducer': partForm,
  'initialValues': {
    'classification': 'R',
    'manualMadStatus': false,
  },
};

export const TRANSFER_FORM = {
  'name': 'transfer',
  'reducer': transferForm,
};

export const WAREHOUSE_DENIAL_CAUSE_FORM = {
  'name': 'warehouseDenialCauses',
  'reducer': warehouseDenialCauseForm,
  'initialValues': {
    'code': '',
    'name': '',
    'moveToTMP': false,
    'status': true,
  },
};

export const SHIFT_FORM = {
  'name': 'shifts',
  'reducer': shiftForm,
  'initialValues': {
    'code': '',
    'name': '',
    'orders': [],
    'labelsEmissionTime': '',
    'dispatchTime': '',
    'days': [],
    'status': true,
  },
};

export const ZONE_FORM = {
  'name': 'zones',
  'reducer': zoneForm,
  'initialValues': {
    'code': null,
    'name': '',
    'lines': 1,
    'pickingTime': 1,
    'people': 1,
    'status': true,
    'locations': [],
  },
};

export const SCANNING_FORM = {
  'name': 'scanning',
  'reducer': scanningForm,
};

export const SCANNING_WAREHOUSE_DENIED_FORM = {
  'name': 'scanningWarehouseDenied',
  'reducer': scanningWarehouseDenialCauseForm,
};

export const INVOICE = {
  'name': 'invoice',
  'reducer': invoiceForm,
};

export const ICC_CATEGORIES_PARAMETERS = {
  'name': 'iccCategoriesParameters',
  'reducer': iccCategoriesParametersForm,
};

export const ICC_MAD_PARAMETERS = {
  'name': 'iccMadParameters',
  'reducer': iccMadParametersForm,
};

export const CHECKING_FORM = {
  'name': 'checking',
  'reducer': checkingForm,
};

export const INVOICING_FORM = {
  'name': 'invoicing',
  'reducer': invoicingForm,
};

export const STOCK_ADJUSTMENT_FORM = {
  'name': 'stockAdjustment',
  'reducer': stockAdjustmentForm,
};

export const QUALITY_ASSURANCE_ORDERS_FORM = {
  'name': 'qualityAssuranceOrders',
  'reducer': qualityAssuranceOrdersForm,
};

export const TECHNICIAN_ASSIGNMENT_FORM = {
  'name': 'techniciansAssignment',
  'reducer': techniciansAssignmentForm,
};

export const DISPATCH_ORDER_FORM = {
  'name': 'dispatchOrdersForm',
  'reducer': dispatchOrderForm,
  'initialValues': {
    'orderId': '',
    'status': '',
    'statusDescription': '',
    'dealerId': '',
    'anticipatedInvoice': '',
    'type': '',
    'addDate': '',
    'addUser': '',
    'updateDate': '',
    'updateUser': '',
    'vehiclesArray': [],
    'sendOrder': false,
    'approveOrder': '',
    'processOrder': false,
    'notificateTo': '',
  },
};

export const USER_FORM = {
  'name': 'user',
  'reducer': userForm,
};

export const MAIL_GROUP_FORM = {
  'name': 'mailGroup',
  'reducer': mailGroupForm,
};

export const ADVISOR_MANAGEMENT_FORM = {
  'name': 'advisorManagementForm',
  'reducer': advisorManagementForm,
};

export const EXEMPTION_MANAGEMENT_FORM = {
  'name': 'exemptionManagementForm',
  'reducer': exemptionManagementForm,
};

export const CLIENT_MANAGEMENT_FORM = {
  'name': 'clientManagement',
  'reducer': clientManagementForm,
};
